"use strict";

import angular from "angular";

import template from "./loading-animated.component.html";
import "./themes/loading-animated.component.scss";
import "./themes/loading-animated-dark.component.scss";

class LoadingAnimatedComponent {
    constructor() {}

    $onInit() {}

    $onChanges(changes) {}
}

export { LoadingAnimatedComponent };

LoadingAnimatedComponent.$inject = [];

const name = "loadingAnimatedComponent";
const def = {
    bindings: {
            type: "@"
        },
        controller: LoadingAnimatedComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
